/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable import/prefer-default-export */
import { UseFormMethods } from "react-hook-form";
import { CompoundFeedDatabase, ReportingType } from "../../../graphql/types";
import featureFlags from "../utils/featureFlags";

const getDefaultDatabase = () => {
  if (featureFlags.gfli3) {
    return CompoundFeedDatabase.Gfli_3_0;
  }
  if (featureFlags.databaseGFLI_2_2) {
    return CompoundFeedDatabase.Gfli_2_2;
  }
  return CompoundFeedDatabase.Gfli;
};

export const filterDatabaseOption = (
  initialOption: any,
  reportingType?: ReportingType,
) => {
  let filteredOption;
  if (reportingType && reportingType === ReportingType.Flag) {
    filteredOption = CompoundFeedDatabase.Afp_7_0Flag;
  } else if (initialOption !== CompoundFeedDatabase.Afp_7_0Flag) {
    filteredOption = initialOption;
  } else {
    filteredOption = getDefaultDatabase();
  }
  return filteredOption;
};

export const getInitialDatabaseValue = <D>(
  formContext: UseFormMethods,
  fieldItemPrefix: string,
  userProfile: any,
) => {
  const initValue: D = formContext.getValues(
    `${fieldItemPrefix}.databaseFoundation`,
  );
  const reportingType = formContext.getValues(
    `${fieldItemPrefix}.reportingType`,
  );
  if (!initValue) {
    const userPreferenceOption = userProfile.getUserDatabasePrefs()
      .databaseType as D;
    return filterDatabaseOption(userPreferenceOption, reportingType) as D;
  }
  return filterDatabaseOption(initValue, reportingType) as D;
};
